import { Timestamp } from "firebase/firestore";
import { INewProject } from "../interfaces/new-project.interface";
import { createProject } from "../services/firestore.service";
import { useAppDispatch } from "../hooks";
import { dismiss } from "../slices/dialogsSlice";

interface AddProjectDialogProps {
    updateProjects: () => void;
    dialogId: number;
}
export const AddProjectDialog = ({ updateProjects, dialogId }: AddProjectDialogProps) => {
    const dispatch = useAppDispatch();

    const close = () => {
        dispatch(dismiss(dialogId));
    };

    const saveProject = (e) => {
        e.preventDefault();

        let data = new FormData(e.target);

        let newProject: INewProject = {
            title: data.get("title").toString(),
            description: data.get("description").toString(),
            createDate: new Timestamp(new Date().getTime() / 1000, 0),
            archived: false,
            complete: false,
        };

        createProject(newProject).then(() => {
            updateProjects();
            close();
        });
    };

    return (
        <>
            <form onSubmit={saveProject}>
                <h1>Add a new Project</h1>
                <input placeholder="Title" name="title" />
                <input placeholder="Description" name="description" />
                <button type="submit">Save</button>
            </form>
            <button className="warn" onClick={close}>
                Cancel
            </button>
        </>
    );
};
